import LogPage from '../../../components/package/LogPage.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class packageLogPage extends InlineComponent {
  define() {
    this.component = LogPage;
  }
};
